import React from 'react';
import { Linkedin, Youtube, Instagram } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-brand-bg/40 backdrop-blur-sm border-t border-brand-surface py-8 sm:py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="mb-4 sm:mb-5">
              <a href="https://www.valuebell.studio/" target="_blank" rel="noopener noreferrer">
                <img
                  src={`${process.env.PUBLIC_URL}/valuebell-logo-white.png`}
                  alt="ValueBell Logo"
                  className="w-28 sm:w-36 object-contain"
                />
              </a>
            </div>
            <p className="text-slate-400 text-xs sm:text-sm leading-relaxed">
              We Produce Valuable Podcasts. A-Z Podcast Solutions. Our goal is simple: to help you thrive.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-3 sm:mb-4 text-sm sm:text-base">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="https://www.valuebell.studio/" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-orange-400 transition-colors duration-200 text-xs sm:text-sm">Home</a></li>
              <li><a href="https://www.valuebell.studio/about" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-orange-400 transition-colors duration-200 text-xs sm:text-sm">About Us</a></li>
              <li><a href="https://www.valuebell.studio/contact" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-orange-400 transition-colors duration-200 text-xs sm:text-sm">Contact</a></li>
              <li><a href="https://www.valuebell.studio/our-studios" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-orange-400 transition-colors duration-200 text-xs sm:text-sm">Studios</a></li>
              <li><a href="https://www.valuebell.studio/podcast-guest-list" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-orange-400 transition-colors duration-200 text-xs sm:text-sm">Guest List</a></li>
            </ul>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="pt-6 sm:pt-8 border-t border-brand-surface flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-slate-400 text-xs sm:text-sm text-center sm:text-left">
            © 2026 VALUEBOT. All rights reserved.
          </p>
          <div className="flex items-center gap-3 sm:gap-4">
            <a href="https://www.linkedin.com/company/valuebell/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-brand-surface-2 hover:bg-orange-500 rounded-lg flex items-center justify-center transition-colors duration-200 group">
              <Linkedin className="w-4 h-4 text-slate-400 group-hover:text-white" />
            </a>
            <a href="https://youtube.com/@valuebellpodcast?si=UaokaamGuukq4eDD" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-brand-surface-2 hover:bg-orange-500 rounded-lg flex items-center justify-center transition-colors duration-200 group">
              <Youtube className="w-4 h-4 text-slate-400 group-hover:text-white" />
            </a>
            <a href="https://www.instagram.com/valuebell_podcast?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-brand-surface-2 hover:bg-orange-500 rounded-lg flex items-center justify-center transition-colors duration-200 group">
              <Instagram className="w-4 h-4 text-slate-400 group-hover:text-white" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
